import React, { useEffect, useState } from 'react'
import { useAuth } from '../../context/AuthContext';
import { faSpinner, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { downloadXmlFomString } from '../../services/XMLService';
import { toFormatTime } from '../../services/DateService';

import './GeneratedHistory.css'

const GeneratedHistory = () => {

    const [statsOpen, setStatsOpen] = useState(false);
    const [stats, setStats] = useState();

    const {
        currentUser,
        userData,
        loadingAction,
        fetchGeneratedHistory,
        generatedHistory
    } = useAuth();

    useEffect(() => {
        fetchGeneratedHistory(currentUser.uid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setStats({
            totalLines: generatedHistory.reduce((acc, curr) => acc + curr.lines, 0),
            totalTert: generatedHistory.reduce((acc, curr) => acc + (curr.tertCompany ? 1 : 0), 0),
            totalAchizitii: generatedHistory.reduce((acc, curr) => acc + (curr.type === "achizitii" ? 1 : 0), 0),
            totalLivrari: generatedHistory.reduce((acc, curr) => acc + (curr.type === "livrari" ? 1 : 0), 0),
            totalValStat: generatedHistory.reduce((acc, curr) => acc + (curr.valStat ? 1 : 0), 0),
            totalReviz: generatedHistory.reduce((acc, curr) => acc + (curr.reviz ? 1 : 0), 0),
            medLines: Math.ceil(generatedHistory.reduce((acc, curr) => acc + curr.lines, 0) / generatedHistory.length),
        })
    }, [generatedHistory])

    // Admin function to load all history
    const loadAllHistory = () => {
        const userInput = window.prompt('Nr of entries to load (default: 10):');
        if (userInput === null) return; // User hit "Cancel"
        let nrToLoad = 10;
        if (userInput !== null && userInput !== "") {
            nrToLoad = +userInput;
        }
        fetchGeneratedHistory("all", nrToLoad);
    }

    if (loadingAction) return <FontAwesomeIcon className='spinner' icon={faSpinner}/>
    if (generatedHistory.length === 0) return <div className='gh-empty'>Nu aveți declarații generate în istoric</div>

    return (
        <>
            {/* ── Header ───────────────────────────────────────────────── */}
            <div className='gh-header'>
                <div className='gh-header-top'>
                    <div>
                        <h2 className='gh-title'>Istoric declarații generate</h2>
                        <p className='gh-subtitle'>Ultimele 10 declarații generate în format XML</p>
                    </div>
                    <div className='gh-header-actions'>
                        {generatedHistory.length > 0 &&
                            <div className='button-secondary' onClick={() => setStatsOpen(!statsOpen)}>
                                Statistici
                            </div>
                        }
                        {userData.data && userData.data.admin && (+userData.data.accessLevel > 9) &&
                            <div className='button-secondary' onClick={() => loadAllHistory()}>
                                Istoric platformă
                            </div>
                        }
                    </div>
                </div>
            </div>

            {/* ── Stats panel ──────────────────────────────────────────── */}
            {statsOpen && generatedHistory.length > 0 && stats &&
                <div className='gh-stats-panel'>
                    <span className='gh-stats-title'>Statistici — ultimele 10 declarații</span>
                    <div className='gh-stats-grid'>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.totalLines}</span>
                            <span className='gh-stat-label'>Total linii</span>
                        </div>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.medLines}</span>
                            <span className='gh-stat-label'>Medie linii / decl.</span>
                        </div>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.totalAchizitii}</span>
                            <span className='gh-stat-label'>Achiziții</span>
                        </div>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.totalLivrari}</span>
                            <span className='gh-stat-label'>Livrări</span>
                        </div>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.totalValStat}</span>
                            <span className='gh-stat-label'>Val. statistică</span>
                        </div>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.totalReviz}</span>
                            <span className='gh-stat-label'>Revizuite</span>
                        </div>
                        <div className='gh-stat-card'>
                            <span className='gh-stat-value'>{stats.totalTert}</span>
                            <span className='gh-stat-label'>Terțe</span>
                        </div>
                    </div>
                </div>
            }

            {/* ── History list ─────────────────────────────────────────── */}
            <div className='gh-history-list'>
                {generatedHistory.map((generated, id) => (
                    <div key={id + generated.fileName} className='gh-card'>

                        <div className='gh-card-main'>
                            <span className='gh-card-name'>
                                {generated.generatedFileName ? generated.generatedFileName : generated.fileName}
                            </span>

                            <div className='gh-card-meta'>
                                <span className='gh-card-meta-item'>
                                    {generated.date} {toFormatTime(generated.timeStamp.toDate())}
                                </span>
                                <span className='gh-card-meta-sep'></span>
                                <span className='gh-card-meta-item'>{generated.company}</span>
                                <span className='gh-card-meta-sep'></span>
                                <span className='gh-lines-badge'>{generated.lines} linii</span>
                            </div>

                            <div className='gh-card-tags'>
                                {generated.type &&
                                    <span className={`gh-tag gh-tag--${generated.type}`}>
                                        {generated.type === 'achizitii' ? 'Achiziții' : 'Livrări'}
                                    </span>
                                }
                                {generated.tertCompany && <span className='gh-tag gh-tag--tert'>Terță</span>}
                                {generated.reviz && <span className='gh-tag gh-tag--reviz'>Revizuită</span>}
                                {generated.hasErrors && <span className='gh-tag gh-tag--error'>Cu erori</span>}
                            </div>

                            {userData.data && userData.data.admin && (+userData.data.accessLevel > 9) &&
                                <span className='gh-card-admin'>{generated.uid} — {generated.name}</span>
                            }
                        </div>

                        <div className='gh-card-actions'>
                            {!generated.generatedXML ?
                                <span className='gh-unavailable'>Descărcare indisponibilă</span> :
                                <div className='button-secondary selected-btn'
                                    onClick={() => downloadXmlFomString(generated.generatedXML, generated.generatedFileName ? generated.generatedFileName : generated.fileName)}>
                                    <FontAwesomeIcon icon={faDownload} />
                                    Descarcă
                                </div>
                            }
                        </div>

                    </div>
                ))}
            </div>
        </>
    )
}

export default GeneratedHistory
